import { Currency } from '@/core/currency/interfaces';

const PAB: Currency = {
    name: 'Panamanian Balboa',
    demonym: 'Panamanian',
    majorSingle: 'Balboa',
    majorPlural: 'Balboa',
    codeNumeric: '590',
    symbol: 'B/.',
    symbolNative: 'B/.',
    minorSingle: 'Centésimo',
    minorPlural: 'Centésimos',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'PAB',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default PAB;
